import {usePaginatedQuery} from '../../../../util/hooks/use-paginated-query';

import GET_BULK_EDITS from '../graphql/queries/get-bulk-edits.graphql';

const LIMIT = 50;

export const useGetBulkEdits = () => {
    const {
        items: bulkEdits,
        isLoading,
        isFirstLoad,
        error,
        hasNextPage,
        fetchMoreRows,
    } = usePaginatedQuery({
        // @ts-expect-error
        query: GET_BULK_EDITS,
        queryKey: 'bulkEdits',
        limit: LIMIT,
    });

    return {
        bulkEdits,
        isLoading,
        isFirstLoad,
        error,
        hasNextPage,
        fetchMoreRows,
    };
};
